import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/capsule.svg has a stroke color. Please outline strokes in figma before exporting it to svg.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/capsule.svg
 */
const IconCapsule: IconComponent = ({
  size = 24,
  color = '#ffffff',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M17.978 6.978a5.978 5.978 0 00-11.956 0v10.044a5.978 5.978 0 1011.956 0V6.978z"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeMiterlimit={10}
    />
  </svg>
);

export default IconCapsule;
